"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var LinkButton_1 = __importDefault(require("../../Button/LinkButton"));
var components_1 = require("../components");
var Label_1 = __importDefault(require("../components/Label"));
var Form_1 = require("../Form");
var StyledLabel = styled_components_1.default(function (props) { return react_1.default.createElement(Label_1.default, __assign({}, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: -40px;\n  @media only screen and (max-width: 500px) {\n    margin-top: 0;\n  }\n"], ["\n  margin-top: -40px;\n  @media only screen and (max-width: 500px) {\n    margin-top: 0;\n  }\n"])));
var StyledRow = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: grid;\n  grid-template-columns: auto 20px;\n  align-items: center;\n  margin-bottom: 1em;\n  column-gap: 0.5em;\n"], ["\n  position: relative;\n  display: grid;\n  grid-template-columns: auto 20px;\n  align-items: center;\n  margin-bottom: 1em;\n  column-gap: 0.5em;\n"])));
var CloseIcon = styled_components_1.default(icons_1.CloseCircleFilled)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #005285;\n  justify-self: flex-end;\n  font-size: 16px;\n"], ["\n  color: #005285;\n  justify-self: flex-end;\n  font-size: 16px;\n"])));
var Divider = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-bottom: 1px dashed #d5e1eb;\n  margin-bottom: 1em;\n"], ["\n  border-bottom: 1px dashed #d5e1eb;\n  margin-bottom: 1em;\n"])));
var FieldList = function (_a) {
    var _b;
    var name = _a.name, label = _a.label, htmlFor = _a.htmlFor, children = _a.children, border = _a.border, isAddDisabled = _a.isAddDisabled;
    var values = Form_1.useFormContext().values;
    if (!((_b = values[name]) === null || _b === void 0 ? void 0 : _b.length)) {
        values[name] = [''];
    }
    return (react_1.default.createElement(formik_1.FieldArray, { name: name }, function (_a) {
        var push = _a.push, remove = _a.remove;
        return (react_1.default.createElement(components_1.Field, null,
            label && react_1.default.createElement(StyledLabel, { htmlFor: htmlFor }, label),
            react_1.default.createElement("div", null,
                (values[name] || []).map(function (_, index) { return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(StyledRow, { key: index },
                        children({ name: name, index: index }),
                        react_1.default.createElement(CloseIcon, { onClick: function () { return remove(index); } })),
                    border && react_1.default.createElement(Divider, null))); }),
                !isAddDisabled && (react_1.default.createElement(LinkButton_1.default, { type: "button", onClick: function () { return push(undefined); } }, "+ P\u0159idat dal\u0161\u00ED")))));
    }));
};
FieldList.defaultProps = {
    label: undefined,
    border: false,
    isAddDisabled: undefined,
};
exports.default = FieldList;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
